var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['cabecera', _vm.porlet.attr.mode || 'light']},[_c('h1',[_vm._v(_vm._s(_vm.ficha.attr.title || 'Ficha'))]),_c('div',{staticClass:"cabecera-left"},[_vm._t("MenuActions"),(_vm.ficha.attr.estado)?_c('el-tag',[_vm._v(_vm._s(_vm.ficha.attr.estado))]):_vm._e(),_vm._t("OpenDrawerLeft"),_vm._t("OpenDrawerRight")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }